import RegisterModal from './Register';
export default RegisterModal;
